<template>
  <div style="width: 100%; height: 100%">
    <router-view />
    <audio id="myAudio" :src="require('@/assets/mp3/jb.mp3')" :loop="loop"></audio>
  </div>
</template>

<script>
import { formatDateTime } from "@/utils/timeFormat";
export default {
  data() {
    return {
      list: [],
      showData: {},
      living: null,
      dialogVisible: false,
      loop: false,
    };
  },
  mounted() {
  },
  watch: {
    list: {
      handler(newValue, oldValue) {
        if (newValue && newValue[0]) {
          if (JSON.stringify(newValue) != JSON.stringify(oldValue)) {
            this.executeShowData(newValue[0]);
          }
        }
      },
      deep: true,
    },
  },
  methods: {
    executeShowData(data) {
      if (this.showData == {}) {
        this.showData = {
          alertLevel: data.AlertLevel,
          alertTime: data.AlertTime,
          creationTime: data.CreationTime,
          currentData: data.CurrentData,
          dangerThresholdValue: data.DangerThresholdValue,
          deviceId: data.DeviceId,
          deviceName: data.DeviceName,
          deviceNum: data.DeviceNum,
          deviceType: data.DeviceType,
          deviceTypeStr: data.DeviceTypeStr,
          eliminateAlerts: data.EliminateAlerts,
          genId: data.GenId,
          handleDesc: data.HandleDesc,
          handleTime: data.HandleTime,
          handleUid: data.HandleUid,
          handled: data.Handled,
          handler: data.Handler,
          heading: data.Heading,
          id: data.Id,
          messageType: data.MessageType,
          messageTypeStr: data.MessageTypeStr,
          readed: data.Readed,
          safeThresholdValue: data.SafeThresholdValue,
          ...data,
        };
        let dataClass =
          data.AlertLevel == 1
            ? "data-1"
            : data.AlertLevel == 2
              ? "data-2"
              : "data-3";
        let divText = `<div class='alarm ${dataClass}'>
            <div class="title">${data.AlertLevel == 1
            ? "一级警报"
            : data.AlertLevel == 2
              ? "二级警报"
              : "三级警报"
          }</div>
            <div class="item">
              <div class="item-label">机组编号：</div>
              <div class="item-value">${data.GenName}</div>
            </div>
            <div class="item">
              <div class="item-label">报警原因：</div>
              <div class="item-value">${data.DeviceTypeStr}</div>
            </div>
            <div class="item">
              <div class="item-label">报警时间：</div>
              <div class="item-value">${formatDateTime(data.AlertTime)}</div>
            </div>
            <div class="button cursorPointer" onClick="jbNotifyClick()">
              <div>
                立即处理
              </div>
            </div>
          </div>`;
        let customClass = "alarmClass cursorDefault";
        console.log("data", data);
        if (data.AlertLevel == 1) {
          customClass = "alarmClass2 cursorDefault";
          divText = `<div class='alarm ${dataClass}'>
            <div class="image">
            </div>
            <div class="result">
            </div>
            <div class="title">
              <div class="icon"></div>
              <div class="text text-color">一级警报</div>
            </div>
            <div class="video">

  <div
    class="video-displacement"
    :style="${`--angle:${data.Heading}deg;--data:${data.CurrentData + 40}vh;`}"
  >
    <div class="d1"></div>
    <div class="d2"></div>
    <div class="d3"></div>
    <div class="d4"></div>
    <div class="d5"></div>
    <div class="d6"></div>
    <div class="t1">
      <i class="icon el-icon-caret-bottom"></i>
      <div class="text">N</div>
    </div>
    <div class="t2">
      <i class="icon el-icon-caret-left"></i>
      <div class="text">E</div>
    </div>
    <div class="t3">
      <i class="icon el-icon-caret-top"></i>
      <div class="text">S</div>
    </div>
    <div class="t4">
      <i class="icon el-icon-caret-right"></i>
      <div class="text">W</div>
    </div>
    <div
      class="moving-point moving-point-animation-no"
      id="ces"
    >
      <div></div>
    </div>
  </div>
            </div>
            <div class="content text-color">
              <div class="item">
                机组编号：${data.GenName}
              </div>
              <div class="item">
                报警原因：${data.DeviceTypeStr}
              </div>
              <div class="item">
                报警时间：${formatDateTime(data.AlertTime)}
              </div>
            </div>
            <div class="button cursorPointer"  onClick="jbNotifyClick()">
            立即处理</div>
          </div>`;
        }
        this.living = this.$alert(divText, {
          dangerouslyUseHTMLString: true,
          showConfirmButton: false,
          closeOnClickModal: false,
          showClose: false,
          customClass: customClass,
        });
        if (data.AlertLevel == 1) {
          this.loop = true;
        } else {
          this.loop = false;
        }
        const audio = document.getElementById("myAudio");
        if (data.AlertLevel == 1 || data.AlertLevel == 2) {
          audio.play();
        }
      } else {
      }
    },
    jbNotifyClick(row) {
      if (this.living) {
        this.$msgbox.close();
        if (this.showData.AlertLevel == 1) {
          let divText = `<div class='alarm data-1'>
            <div class="title">一级警报
            </div>
            <div class="item">
              <div class="item-label">机组编号：</div>
              <div class="item-value">${this.showData.GenName}</div>
            </div>
            <div class="item">
              <div class="item-label">报警原因：</div>
              <div class="item-value">${this.showData.DeviceTypeStr}</div>
            </div>
            <div class="item">
              <div class="item-label">报警时间：</div>
              <div class="item-value">${formatDateTime(this.showData.AlertTime)}</div>
            </div>
            <div class="button cursorPointer" onClick="jbNotifyClick_2()">
              <div>
                立即处理
              </div>
            </div>
          </div>`;
          this.$alert(divText, {
            dangerouslyUseHTMLString: true,
            showConfirmButton: false,
            closeOnClickModal: false,
            showClose: false,
            customClass: "alarmClass cursorDefault",
          });
        } else {
          this.dialogVisible = true;
          console.log("测试", this.showData);
        }
        // this.list.splice(0, 1);
        // this.ReadedAlert({})
        // this.showData = "";
      }
    },
    jbNotifyClick_2() {
      this.$msgbox.close();
      this.readedAlert();
    },
    readedAlert() {
      // ReadedAlert({ Id: this.showData.Id }).then((res) => {
      this.showData = {};
      this.dialogVisible = false;
      const audio = document.getElementById("myAudio");
      audio.pause();
      // });
    },
  },
};
</script>

<style lang="scss">
.el-notification {
  .notify {
    color: red;
    margin-right: 10px;

    .text {
      color: #409eff;
      text-align: right;
    }
  }

  .el-notification__group {
    flex: 1;
  }
}

.alertCustomClass {
  width: 800px !important;

  .alert {
    height: 600px;
    // width: 800px;
  }
}

.el-message-box__wrapper {
  z-index: 9999 !important;
}

.v-modal {
  // z-index: 9997 !important;
}

.dialog-class {

  // z-index: 9999 !important;
  .el-dialog {
    margin: 0px !important;
    top: calc(50% - 350px) !important;
    left: calc(50% - 550px);
    height: 700px;
    width: 1100px;
    position: absolute;
    background-image: url("@/assets/image/wind/kuang4.png") !important;
    background-size: 100% 100%;
    background-color: #0000 !important;
    padding: 50px 70px !important;
  }

  .el-dialog__body {
    padding: 0px !important;
    height: 100%;
  }

  .el-dialog__header {
    height: 0px;
    padding: 0px;
  }
}
</style>
<style lang="scss">
.video-displacement {
  //   background-color: #aaa;
  top: 160px;
  position: relative;

  .d1,
  .d2,
  .d3,
  .d4,
  .d5,
  .d6 {
    position: absolute;
    border-radius: 50%;
    width: calc(var(--px) * 2);
    height: calc(var(--px) * 2);
    top: calc(50% - var(--px));
    left: calc(50% - var(--px));
  }

  .d1 {
    --px: 20px;
    border: 1px dashed red;
  }

  .d2 {
    --px: 30px;
    border: 1px dashed yellow;
  }

  .d3 {
    --px: 40px;
    border: 2px solid green;
  }

  .d4 {
    --px: 50px;
    border: 1px dashed yellow;
  }

  .d5 {
    --px: 60px;
    border: 1px dashed red;
  }

  .d6 {
    --px: 70px;
    border: 1px solid dimgray;
  }

  .t1,
  .t2,
  .t3,
  .t4 {
    --px: 70px;
    position: absolute;
    color: blue;

    .icon {
      position: absolute;
      height: 20px;
      width: 20px;
      text-align: center;
      font-size: 14px;
      line-height: 20px;
    }
  }

  .t1 {
    width: 20px;
    top: calc(50% - var(--px) - 20px);
    left: calc(50% - 10px);
    font-size: 16px;

    .icon {
      top: 14px;
    }

    .text {
      height: 20px;
      width: 100%;
      text-align: center;
    }
  }

  .t2 {
    width: 20px;
    height: 20px;
    top: calc(50% - 10px);
    left: calc(50% + var(--px) + 0px);
    font-size: 16px;

    .icon {
      left: -14px;
    }

    .text {
      line-height: 20px;
      height: 20px;
      width: 100%;
      text-align: center;
    }
  }

  .t3 {
    width: 20px;
    height: 20px;
    top: calc(50% + var(--px) + 0px);
    left: calc(50% - 10px);
    font-size: 16px;

    .icon {
      top: -14px;
    }

    .text {
      line-height: 20px;
      height: 20px;
      width: 100%;
      text-align: center;
    }
  }

  .t4 {
    width: 20px;
    height: 20px;
    top: calc(50% - 10px);
    left: calc(50% - var(--px) - 20px);
    font-size: 16px;

    .icon {
      left: 14px;
    }

    .text {
      line-height: 20px;
      height: 20px;
      width: 100%;
      text-align: center;
    }
  }

  .moving-point-animation-no {
    transform: rotate(var(--angle));

    >div {
      top: calc(50% - (var(--data) * 0.092592) + 0.277778vh);
    }
  }

  .moving-point {
    height: 100%;
    width: 100%;
    position: absolute;

    >div {
      position: absolute;
      height: 6px;
      width: 6px;
      border-radius: 50%;
      left: calc(50% - 3px);
      background-color: white;
    }
  }
}

.alarmClass {
  background: none !important;
  padding: 0px !important;
  border: none !important;
  width: 500px !important;

  .el-message-box__header {
    display: none;
  }

  .el-message-box__btns {
    display: none;
  }

  .el-message-box__content {
    padding: 0px !important;
  }

  .data-1 {
    background-image: url("@/assets/image/wind/kuang1_1.png") !important;
    background-size: 100% 100%;

    .button {
      >div {
        background-color: rgb(190, 35, 7);
        border: 2px solid rgb(180, 72, 53);
      }
    }
  }

  .data-2 {
    background-image: url("@/assets/image/wind/kuang2.png") !important;
    background-size: 100% 100%;

    .button {
      >div {
        background-color: rgb(215, 120, 1);
        border: 2px solid rgb(247, 184, 107);
      }
    }
  }

  .data-3 {
    background-image: url("@/assets/image/wind/kuang3.png") !important;
    background-size: 100% 100%;

    .button {
      >div {
        background-color: rgb(140, 145, 1);
        border: 1px solid rgb(243, 245, 164);
      }
    }
  }

  .alarm {
    height: 400px;
    width: 500px;
    padding: 35px;

    >.title {
      text-align: center;
      font-size: 24px;
      color: white;
    }

    .item {
      margin-top: 30px;
      display: flex;
      font-size: 20px;
      padding: 0px 40px;

      >.item-label {
        color: rgba($color: #aaa, $alpha: 0.5);
        width: 100px;
      }

      .item-value {
        color: white;
      }
    }

    >.button {
      display: flex;
      justify-content: center;
      margin-top: 50px;

      >div {
        width: 120px;
        height: 50px;
        padding: 10px;
        text-align: center;
        border-radius: 50px;
        color: white;
        font-size: 18px;
      }
    }
  }
}

.alarmClass2 {
  background-image: url("@/assets/image/wind_home/mapbj2.png") !important;
  background-size: 100% 100%;
  padding: 0px !important;
  border: none !important;
  width: 100vw !important;
  height: 100vh !important;

  .alarm {
    height: 100vh;
    width: 100vw;

    .image {
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: url("@/assets/image/wind/kuang1.png");
      background-size: 100% 100%;
    }

    .result {
      position: absolute;
      width: 100%;
      height: 100%;
      background-image: radial-gradient(circle at 50% 50%, #f000, #f003, #f009);
      background-size: 100% 100%;
      animation: blink 1.5s infinite;
    }

    @keyframes blink {
      0% {
        opacity: 1;
      }

      50% {
        opacity: 0.2;
      }

      100% {
        opacity: 1;
      }
    }

    .text-color {
      color: white;
      text-shadow: 0 0 10px red;
    }

    .title {
      position: absolute;
      width: 600px;
      height: 160px;
      display: flex;
      align-items: center;
      top: 140px;
      left: calc(50% - 300px);

      .icon {
        background-image: url("@/assets/image/wind/kuang1_icon.png");
        background-size: 100% 100%;
        height: 160px;
        width: 160px;
      }

      .text {
        font-size: 70px;
        letter-spacing: 10px;
        margin-left: 50px;
      }
    }

    .video {
      height: 300px;
      width: 400px;
      position: absolute;
      top: calc(50% - 200px);
      left: calc(50% - 300px - 20px - 400px);

      >.video-image {
        height: 100%;
        width: 100%;
        background-image: url("@/assets/image/wind/yuanhuan.png");
        background-size: 100% 100%;
      }
    }

    .content {
      position: absolute;
      width: 600px;
      height: 40px;
      top: 360px;
      left: calc(50% - 300px + 100px);
      font-size: 30px;

      .item {
        margin-bottom: 80px;
      }
    }

    .button {
      position: absolute;
      width: 200px;
      height: 80px;
      top: 700px;
      left: calc(50% - 100px);
      text-align: center;
      color: white;
      background-color: red;
      line-height: 80px;
      font-size: 30px;
      border-radius: 40px;
    }
  }

  .el-message-box__header {
    display: none;
  }

  .el-message-box__btns {
    display: none;
  }

  .el-message-box__content {
    padding: 0px !important;
  }
}

.custom-class {}

.video-displacement {}
</style>
